import { SHOW_MODAL, MODAL_CONFIRM, MODAL_CANCEL, HIDE_MODAL } from '@applyboard/ab-common';

// eslint-disable-next-line @typescript-eslint/no-explicit-any

function generateModalActions(modal_name) {
  return {
    show: function show() {
      return {
        __modal: 1,
        type: SHOW_MODAL,
        modal_name: modal_name
      };
    },
    confirm: function confirm(confirm_value) {
      return {
        __modal: 1,
        type: MODAL_CONFIRM,
        modal_name: modal_name,
        value: confirm_value
      };
    },
    cancel: function cancel(cancel_value) {
      return {
        __modal: 1,
        type: MODAL_CANCEL,
        modal_name: modal_name,
        value: cancel_value
      };
    },
    hide: function hide() {
      return {
        __modal: 1,
        type: HIDE_MODAL,
        modal_name: modal_name
      };
    }
  };
}
export default generateModalActions;